import React, {Component} from 'react';
import {Card, Embed, Icon, Table, Label, Tab, Dropdown, Button} from 'semantic-ui-react';
import {DateInput} from 'semantic-ui-calendar-react';
import Dropzone from "react-dropzone";

class ReviewSubmissions extends Component {

  /***** Page Functions *****/

  constructor(props) {
    super(props);
    this.state = {
      results:  [],
      results1: [],
      results2: [],
      results3: [],
      dateCreated: null,
      dateRecorded: null,
      User: this.props.User
    };
  }

  componentDidMount() {
    this.getEndorsementsData()
    this.getDesignationsList()
  }

  render() {
    const panes = [
      { menuItem: 'ALL',        render: () => <Tab.Pane attached={false}>{this.renderAsGrid(this.state.results)}</Tab.Pane> },
      { menuItem: 'IN PROCESS', render: () => <Tab.Pane attached={false}>{this.renderCards("orange", "hourglass full", this.state.results1)}</Tab.Pane> },
      { menuItem: 'RECORDED',   render: () => <Tab.Pane attached={false}>{this.renderCards("green", "flag checkered", this.state.results2)}</Tab.Pane> },
      { menuItem: 'REJECTED',   render: () => <Tab.Pane attached={false}>{this.renderCards("red", "user cancel", this.state.results3)}</Tab.Pane> },
    ]
    return (<Tab menu={{color:'blue', inverted: true, pointing: true }} panes={panes} />)
  }
//      { menuItem: 'MANUAL UPLOAD',   render: () => <Tab.Pane attached={false}>{this.renderManualUpload()}</Tab.Pane> },
  renderCards(cardcolor, cardicon, results) {
    var imgObject, embedURL
    if(results.length===0) return

    var cards = results.map(function (tblRow) {
      switch(tblRow.Status) {
        case 1 :
          embedURL = window.fileServerURL + tblRow.LPNumber + "-" + tblRow.DOFDocumentID + ".pdf"
          imgObject = <Embed placeholder="images/barcode_underrev.png" icon="folder open"
                             url={embedURL}/>
          break;
        case 2 :
          embedURL = window.fileServerURL + tblRow.LPNumber + "-" + tblRow.DOFTransactionID + ".pdf"
          imgObject = <Embed placeholder="images/barcode.png" icon="folder open"
                             url={embedURL}/>
          break;
        case 3 :
          imgObject = <p align="center" style={{color:"red"}}><b>TRANSACTION REJECTED</b><br />{tblRow.Notes}</p>
          break;
        default :
      }
      return (
        <Card key={tblRow.DOFRecordingID}>
          <Card.Content>
            <Card.Header>
              {tblRow.LPNumber}
              <Label corner='right' color={cardcolor} icon={cardicon} />
            </Card.Header>
          </Card.Content>
          {imgObject}
          <Card.Content>
            <Card.Meta>
              <span className='date'>
                {tblRow.LM_NAME}<br />
                {tblRow.LM_TYPE}<br />
                Designated: {tblRow.DtDesignated}
              </span>
            </Card.Meta>
            <Card.Description>
              Transaction Number: {tblRow.DOFTransactionID}<br />
              Document ID: {tblRow.DOFDocumentID}
              {tblRow.Status === 2 ? ", Recorded on: " + tblRow.DtRecorded : ""}
            </Card.Description>
          </Card.Content>
          <Card.Content extra>
            <Icon name='user'/>{tblRow.RecordedBy}/{tblRow.DtSubmitted}
          </Card.Content>
        </Card>
      )
    })
    return (
      <Card.Group itemsPerRow="3">{cards}</Card.Group>
    )
  }

  renderAsGrid(results) {
    var tblRows = results.map(function (tblRow) {
      const url = window.fileServerURL
      const subfName = tblRow.LPNumber + "-" + tblRow.DOFDocumentID + ".pdf"
      const recfName = tblRow.LPNumber + "-" + tblRow.DOFTransactionID + ".pdf"
      var dofStatus, recordDt, rowColor
      switch(tblRow.Status) {
        case 2:
          dofStatus = "RECORDED";
          recordDt = <a href={url+recfName} target="blank">{tblRow.DtRecorded}</a>
          rowColor = "green";
          break;
        case 3:
          dofStatus = "REJECTED";
          recordDt=tblRow.Notes;
          rowColor = "red";
          break;
        default:
          dofStatus = "IN PROCESS";
          rowColor = "orange";
          break;
      }
      return (
        <Table.Row key={tblRow.DOFRecordingID} style={{color:rowColor}}>
          <Table.Cell>{tblRow.LPNumber}</Table.Cell>
          <Table.Cell>{tblRow.LM_NAME}</Table.Cell>
          <Table.Cell>{tblRow.LM_TYPE}</Table.Cell>
          <Table.Cell>{tblRow.DtDesignated}</Table.Cell>
          <Table.Cell><a href={url+subfName} target="blank">{tblRow.DtSubmitted}</a></Table.Cell>
          <Table.Cell>{tblRow.DOFTransactionID}</Table.Cell>
          <Table.Cell>{recordDt}</Table.Cell>
          <Table.Cell>{tblRow.DOFDocumentID}</Table.Cell>
          <Table.Cell>{tblRow.RecordedBy}</Table.Cell>
          <Table.Cell>{dofStatus}</Table.Cell>
        </Table.Row>
      )
    })
    return (
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>LP Number</Table.HeaderCell>
            <Table.HeaderCell>Landmark Name</Table.HeaderCell>
            <Table.HeaderCell>Landmark Type</Table.HeaderCell>
            <Table.HeaderCell>Designation Date</Table.HeaderCell>
            <Table.HeaderCell>ACRIS Submission Date</Table.HeaderCell>
            <Table.HeaderCell>ACRIS Transaction ID</Table.HeaderCell>
            <Table.HeaderCell>Recorded Date</Table.HeaderCell>
            <Table.HeaderCell>ACRIS Document ID</Table.HeaderCell>
            <Table.HeaderCell>Recorded By</Table.HeaderCell>
            <Table.HeaderCell>Status</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {tblRows}
        </Table.Body>
      </Table>
    )
  }

  /***** Supporting Functions *****/

  /***** Data Handling ****/
  getEndorsementsData() {
    this.getLatestStatusFromAcris()
  }

  getLatestStatusFromAcris() {
    var rp = require('request-promise');
    const requestData = {request: {"User": this.state.User,}}
    rp({
        url: window.globalAppTrackURL + "GetEndorsements",
        method: "POST",
        headers: {"content-type": "application/json"},
        json: true,
        body: requestData
      }
    )
      .then(function (res) {return res})
      .catch(function (err) {return(err)})

      .then((json) => this.finishUpdating(json))
  }

  finishUpdating(json) {
    for(var i=0;i<4;i++) //0 to 3
      this.startUpdatingResults(i)
  }

  startUpdatingResults(status) {
    var url = window.globalAppTrackURL + "Submissions/" + status;
    fetch(url).then(function (response) {
      return response.json();
    })
      .then(
        (json) => this.finishUpdatingResults(status, json)
      );
  }

  finishUpdatingResults(status, json) {
    switch (status) {
      case 1:
        this.setState({results1: json});
        break;
      case 2:
        this.setState({results2: json});
        break;
      case 3:
        this.setState({results3: json});
        break;
      default:
        this.setState({results: json});
        break;
    }
  }

  renderManualUpload() {
    return (
    <div>
      <b>Select Designation:</b><br />
      <Dropdown
        search selection fluid
        options={this.state.desigs}
        placeholder={'Select Landmark Designation'}
        onChange={this.handleUserSelection}></Dropdown>
      <br />
      <table width="100%">
        <tr>
          <td>
            <b>DOF Transaction ID</b>
          </td>
          <td>
            <b>DOF Document ID</b>
          </td>
          <td>
            <b>Upload Document</b>
          </td>
        </tr>
        <tr>
          <td valign="top">
            <input type="text" placeholder="transaction id..." />
          </td>
          <td valign="top">
            <input type="text" placeholder="document id..." />
          </td>
          <td>
            <Dropzone onDrop={(files) => this.onDrop(files)} accept="application/pdf">
              <div>
                Drop recorded document received from Department of Finance.<br /><br />
                (please note, only PDF files are acceptable)
              </div>
            </Dropzone>
          </td>
        </tr>
        <tr><td colSpan="3">&nbsp;</td></tr>
        <tr>
          <td>
            <b>Date Created</b>
          </td>
          <td />
          <td>
            <b>Date Recorded</b>
          </td>
        </tr>
        <tr>
          <td>
            <DateInput
              inline
              name='dateCreated'
              value={this.state.dateCreated}
              onChange={this.handleDateChange}
            />
          </td>
          <td />
          <td>
            <DateInput
              inline
              name='dateRecorded'
              value={this.state.dateRecorded}
              onChange={this.handleDateChange}
            />
          </td>
        </tr>
        <tr><td colSpan="2">&nbsp;</td></tr>
        <tr><td colSpan="2">
          <Button color='blue'>Upload!</Button>
        </td></tr>

      </table>

    </div>
    )
  }

  handleDateChange = (event, {name, value}) => {
    if (this.state.hasOwnProperty(name)) {
      this.setState({ [name]: value });
    }
  }

  onDrop(acceptedFiles, rejectedFiles) {
    for (var i = 0; i < acceptedFiles.length; i++) {
      this.uploadSubmission(acceptedFiles[i])
    }
  }
  /***** Data Handling ****/
  getDesignationsList() {
    var url = window.globalAppTrackURL + "LPdropdown";
    fetch(url).then(function (response) {
      return response.json();
    })
      .then(
        (json) => this.finishDesignationsList(json)
      );
  }

  finishDesignationsList(json) {
    this.setState({desigs: json});
  }

  uploadSubmission(res) {
    // var rp = require('request-promise');
    // const requestData = {
    //   request: {
    //     "transactionid": this.state.acrisDocument.transactionNumber,
    //     "documentid": this.state.acrisDocument.documentID,
    //     "lpNumber": this.state.results[0]["LP_NUMBER"],
    //     "createdate": this.state.todaysDate,
    //     "submissiondate": res.SubmissionDate,
    //     "username": this.props.userName,
    //     "numpages": this.state.filesToBeSent[0].numpages,
    //     "status": 1,
    //     "properties": this.state.results
    //   }
    // }
    // rp({
    //     url: window.globalAppTrackURL + "UpdateDatabase",
    //     method: "POST",
    //     headers: {"content-type": "application/json"},
    //     json: true,
    //     body: requestData
    //   }
    // )
    //   .then(function (res) {return res})
    //   .catch(function (err) {return(err)})
    //
    //   .then((json) => this.finishDBUpdate(json))
  }

  finishDBUpdate(json) {

  }


}

export default ReviewSubmissions




// WEBPACK FOOTER //
// ./src/components/ReviewSubmissions.js